/* eslint-disable */
import http from '../http-streaming-common'

class MainCalendarService {
  get (data: any) {
    const params = data.params
    return http.get(data.route, { params })
  }

  post (data: any) {
    return http.post(data.route, data.params)
  }

  put (data: any) {
    return http.put(data.route, data.params)
  }

  delete (data: any) {
    const params = data.params
    return http.delete(data.route, { params })
  }
}

export default new MainCalendarService()
